import React from "react";
import PropTypes from "prop-types";
import placeholder from "assets/img/placeholder.png";
import useMediaQuery from "app/hooks/useMediaQuery";
import { animations } from "react-animation";
import { maskCurrency } from "@helpers/utils";

BienPreview.propTypes = {
  idBien: PropTypes.number,
  tipoBien: PropTypes.string,
  expediente: PropTypes.string,
  precio: PropTypes.string,
  descripcion: PropTypes.string,
  imagenUrl: PropTypes.string,
  imagenBotonVerDetalle: PropTypes.string,
  setCurBien: PropTypes.func,
};

function BienPreview({
  idBien,
  tipoBien,
  expediente,
  precio,
  descripcion,
  imagenUrl = placeholder,
  imagenBotonVerDetalle,
  setCurBien,
  ...props
}) {
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");
  const isIphoneX = useMediaQuery("(min-width: 375px)");

  return (
    <div className="bienes-thumb-container">
      <div
        className={
          isIphoneX
            ? "self-align-end pt-2 pb-3"
            : "self-align-end pt-2 pe-5 pb-3 ps-5"
        }
      >
        <img
          className="img-thumbnail"
          src={imagenUrl}
          width={isIpadPortrait ? 297 : 398}
          height={isIpadPortrait ? 266 : 356}
          style={{
            minWidth: "297px",
            minHeight: "266px",
            borderRadius: "20px",
          }}
          alt="Vista Previa"
        />
      </div>
      <div className="d-flex flex-column justify-content-center pt-0 p-3">
        <div className="text-start fs-5 text-secondary">
          {tipoBien} {expediente}
        </div>
        <div className="text-start fs-5 text-secondary fw-bold">
          ₡ {precio ? maskCurrency(precio) : 0}
        </div>
        <div className="bien-description text-start text-wrap fs-5 pt-2 pb-2">
          {descripcion}
        </div>
        <div className="text-start fs-5">
          <img
            src={imagenBotonVerDetalle}
            className="custom-link"
            style={{ animation: animations.fadeIn }}
            alt="Ver Detalle"
            width={300}
            height={91}
            onClick={() => setCurBien(idBien)}
          />
        </div>
      </div>
    </div>
  );
}

export default BienPreview;
